import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import GlobalState from "./context/GlobalState.jsx";
import "./style.css";
import "react-toastify/dist/ReactToastify.css";

import { ConfigProvider } from "antd";
import { ToastContainer } from "react-toastify";

ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode>
        <GlobalState>
            <ConfigProvider
                theme={{
                    token: { colorPrimary: "#48d1cc" },
                    components: { Button: { colorPrimary: "#48d1cc" } },
                }}
            >
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl
                    pauseOnFocusLoss
                    draggable={false}
                    pauseOnHover
                    theme="colored"
                />
                <App />
            </ConfigProvider>
        </GlobalState>
    </React.StrictMode>
);
